<template>
    <EditUser v-show="user" :user="user" />
  </template>
  <script>
  import EditUser from './add'
  import { getUser } from '@/api/acl'
  
  export default {
    data() {
      return {
        user: null,
        loading: true,
      }
    },
    components: {
      EditUser,
    },
    created() {
      getUser.api(this.$route.params.id).then((res) => {
        this.user = {
          ...res,
          id: this.$route.params.id,
          disabled: this.$route.name.includes('VIEW') ? true : false,
          policies: res.policies.map( i => i.id )
        }
        this.loading = false
      })
    },
  }
  </script>
  